module.exports = __webpack_public_path__ + "img/20_dice[10].f4cc0b6b.png";